import React, { useState } from 'react'
import useCinemaColorsAndIcons from '../hooks/useCinemaColorsAndIcons'
import getCinemaStyles from '../functions/getCinemaStyles'

const SliderBasicLinkButton = ({linkText, ticketButtonClass, cinemas=[], className=''}) => {
    const [mouseOver, setMouseOver] = useState(false)
    const cinemaColorSettings = useCinemaColorsAndIcons()
    const {cinemaColor} = getCinemaStyles(cinemaColorSettings, cinemas)
    const oddSlider = className.search('odd') !== -1 

    const style = cinemaColor && !oddSlider ? !mouseOver ? {
        background: cinemaColor,
        borderColor: cinemaColor
    } : {
        color: cinemaColor,
        borderColor: cinemaColor
    } : {}

    const svgStyle = cinemaColor && !oddSlider && mouseOver ? {
        fill: cinemaColor
    } : {}


    return (
    <div className={"buy-ticket-large button cursor-pointer " + ticketButtonClass} style={style} onMouseOver={() => {setMouseOver(true)}} onMouseOut={() => {setMouseOver(false)}}>
        {ticketButtonClass && 
        <div className='ticket-icon'>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 129.43 128.25" style={svgStyle}>
                <g id="Ebene_2" data-name="Ebene 2">
                    <g id="Ebene_1-2" data-name="Ebene 1">
                        <path className="cls-1" d="M16.53,96.92c-3-4.13-6.29-8.5-9.41-13C4.79,80.55,6.31,78.2,9.31,76Q45.19,50.26,81,24.35c3.1-2.24,6.27-4.4,9.31-6.71,3.21-2.44,5.79-1.88,8,1.29,1.64,2.3,3.21,4.66,5,6.84,2.88,3.52,4.3,6.78.86,11-2.15,2.64-1.57,6.13.52,8.84s5.29,4.28,8.82,2.92c3.85-1.48,6.33-.28,8.42,3,1.71,2.66,3.68,5.14,5.5,7.73,3,4.24,2.73,5.87-1.61,9q-26.27,19-52.59,38Q59.5,116.2,45.72,126.13c-4.35,3.12-5.91,2.87-9.08-1.3-1.3-1.72-2.42-3.59-3.79-5.26-3.25-3.94-5.57-7.62-1.45-12.7,2.15-2.64,1.11-6.13-1.22-8.69s-5.42-3.72-9-2.31C20,96.34,19,97.47,16.53,96.92Zm16.83,15.77,8.1,11L124.84,63.4l-7.87-11c-6.28,1.81-11.88,1.3-15.87-4.11C97,42.68,97.93,37.06,102,31.63c-2.65-3.65-5.28-7.25-8-11L10.35,80.8l8,11.09c6.3-1.73,11.76-1.28,15.71,3.9C38.38,101.48,37.32,107.23,33.36,112.69Z"/>
                        <path className="cls-1" d="M9.31,76l8.9-6.41L57.66,4.46l11.69,7c-1.6,6.58-.26,12.13,5.71,15.66.41.24.81.44,1.21.64l4.53-3.27a9.71,9.71,0,0,1-3.45-1.21c-3-1.67-4.88-4.65-3.94-7.93,1.5-5.25-1.08-7.69-5.11-9.8C65.79,4.22,63.42,2.67,61,1.19c-3.31-2-5.91-1.53-7.9,2-1.9,3.32-4,6.55-5.94,9.82Q28,44.68,8.91,76.34Z"/>
                        <path className="cls-1" d="M32.55,103.1a8.7,8.7,0,0,0-2.37-4.92,8.56,8.56,0,0,0-4.4-2.77c-3.35.09-6.57,1.71-9.76,4.25L4.31,92.59c1.37-2.28,2.75-4.54,4.12-6.82-.44-.61-.87-1.22-1.31-1.85A5.76,5.76,0,0,1,6,81.14q-2.25,3.73-4.51,7.47C-.43,91.77-.9,94.53,2.57,96.72c4.62,2.92,9.36,5.65,13.74,8.27,2.45-.45,2.93-1.88,3.85-2.78,2.76-2.71,5.91-2.92,9.2-1.41A9.75,9.75,0,0,1,32.55,103.1Z"/>
                        <rect className="cls-1" x="68.74" y="43.59" width="11" height="4.59" transform="matrix(0.58, 0.81, -0.81, 0.58, 68.03, -41.17)"/>
                        <rect className="cls-1" x="78.89" y="57.74" width="11" height="4.59" transform="translate(83.73 -43.53) rotate(54.21)"/>
                        <rect className="cls-1" x="89.05" y="71.68" width="11" height="4.59" transform="translate(99.25 -45.98) rotate(54.21)"/>
                        <rect className="cls-1" x="44.13" y="33.01" width="11" height="4.59" transform="translate(25.36 -20.56) rotate(31.09)"/>
                    </g>
                </g>
            </svg>
        </div>
        }
        <span className="button-text text-xlarge-bold">
            {linkText}
        </span>
    </div>
)}

export default SliderBasicLinkButton